import React from 'react';
import { styled } from 'styletron-react';

interface VersionTagProps extends React.HTMLAttributes<HTMLDivElement> {
  pipelineId: string;
  pipelineDate: string;
}

const VersionTagWrapper = styled('div', {
  fontSize: '10px',
  cursor: 'default'
});

/**
 * Prints pipeline information to the console.
 * @param {string} id - The ID of the version.
 * @param {string} date - The date of the version.
 */
function printPipelineInformation(id: string, date: string) {
  // Log the version ID to the console
  console.info('[Version] ID: ' + id);
  // Log the version date to the console
  console.info('[Version] Date: ' + date);
}

export const VersionTag: React.FC<VersionTagProps> = (props) => {
  const { pipelineId, pipelineDate, style, className } = props;

  printPipelineInformation(pipelineId, pipelineDate);

  return (
    <VersionTagWrapper className={className} style={style}>
      <span data-gi="pipeline-id">{pipelineId}</span> started at{' '}
      <span data-gi="pipeline-date">{pipelineDate}</span>
    </VersionTagWrapper>
  );
};
